import { Component } from '@angular/core';

@Component({
  selector: 'app-preguntas-seguridad',
  standalone: false,
  templateUrl: './preguntas-seguridad.component.html',
  styleUrl: './preguntas-seguridad.component.scss'
})
export class PreguntasSeguridadComponent {

}
